export const SET_FEMALE = "SET_FEMALE";
export const SET_MALE = "SET_MALE";
export const SET_OTHER_THIRD_GENDER = "SET_OTHER_THIRD_GENDER";
export const SET_GENDER_STATE = "SET_GENDER_STATE";
